"use client";
import { useState } from "react";
import ICON_ARROW_UP from "@/assets/images/arrow-up.svg";
import ICON_ARROW_UP_DARK from "@/assets/images/arrow_up_white_leagues.svg";
import { useTheme } from "@/context/ThemeContext";

export default function MatchLeagues({ league, matches, render = () => { } }) {
  const { isDark } = useTheme();
  const [isExpanded, setIsExpanded] = useState(true);
  
  const { name, logo } = league;

  return (
    <div className="flex flex-col gap-0 rounded-lg overflow-hidden border border-[var(--theme-border)] bg-[var(--theme-foreground)]">
      <div
        className="flex items-center gap-2 px-3 py-2.5 cursor-pointer bg-[var(--theme-accent)] border-b border-[var(--theme-border)] border-l-4 border-l-[var(--theme-primary)] hover:opacity-95 transition-opacity"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        {logo && <img src={logo} alt={name} className="w-6 h-6 object-contain shrink-0" />}
        <span className="text-sm font-semibold text-[var(--theme-text)] flex-1 min-w-0 truncate">{name}</span>
        <img
          className={`w-5 h-5 shrink-0 transition-transform ${isExpanded ? "rotate-180" : ""}`}
          src={isDark ? ICON_ARROW_UP_DARK : ICON_ARROW_UP}
          alt="arrow-up"
          width={20}
          height={20}
        />
      </div>

      {isExpanded && (
        <div className="flex flex-col p-2 gap-2 bg-[var(--theme-bg)]/50">
          {matches.map((match) => render(match))}
        </div>
      )}
    </div>
  );
}
